"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");require("core-js/modules/es6.array.find");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.function.name");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));require("core-js/modules/es6.regexp.to-string");require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");





























































































































var _lodash = require("lodash");
var _index = require("@/utils/index");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss2")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { uploading: false, //是否正在上传文件
      showRecord: false, //是否显示历史记录
      showPath: false, //是否显示路径表单
      showFile: false, //是否显示上传表单
      brandId: 0, //品牌id
      searchData: { code: '', brandId: '', netMethod: '', controlType: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, //筛选参数
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页参数
      tableData: [], //表格数据
      tableColumns: [{ label: '营销型号', prop: 'name' }, { label: '工厂型号', prop: 'code' }, { label: '品牌名称', prop: 'brandName' }, { label: '配网方式', prop: 'netMethod' }, { label: '操作方式', prop: 'controlType' }], //表头信息
      modelList: [], //型号下拉列表
      brandList: [], //品牌下拉列表
      localeList: [], //语言下拉列表
      pathForm: { fileType: '', brandCode: '', typeCode: '', customDir: '', version: '', locale: '', remark: '' }, //上传路径表单
      pathFormRule: { fileType: [{ required: true, message: '请选择上传类型', trigger: ['blur', 'change'] }], brandCode: [{ required: true, message: '请选择品牌', trigger: ['blur', 'change'] }], typeCode: [{ required: true, message: '请选择产品型号', trigger: ['blur', 'change'] }], version: [{ required: true, message: '请填写版本', trigger: ['blur', 'change'] }], locale: [{ required: true, message: '请选择语言', trigger: ['blur', 'change'] }] }, //上传路径表单校验规则
      uploadForm: { domain: '', fileType: '', brandCode: '', customDir: '', zipFileName: '', downloadUrl: '', unzipOssPath: '', targetOssPath: '', locale: '', uploadStatus: 1, folderPath: '', version: '', remark: '' }, //上传表单
      uploadFormRule: { downloadUrl: [{ required: true, message: '请上传文件', trigger: ['blur', 'change'] }] }, //上传表单校验规则
      fileTypeList: [{ id: 1, name: '设备H5' }, { id: 2, name: '说明书' }, { id: 3, name: '协议隐私' }, { id: 4, name: '后台' }], //文件类型列表
      recordSearchData: { fileType: '', brandCode: '', typeCode: '', page: 1, rows: 10 }, //记录筛选参数
      recordPageData: { page: 1, rows: 10, total: 0, pages: 1 }, //记录分页参数
      recordData: [], //历史记录
      recordColumn: [{ label: '文件类型', prop: 'fileType', formatter: _formatter.staticManageFileTypeFormatter }, { label: '品牌名称', prop: 'brandName' },

      {
        label: '品牌编码',
        prop: 'brandCode' },

      {
        label: '版本号',
        prop: 'version' },

      {
        label: '文件名称',
        prop: 'zipFileName' },

      {
        label: '下载地址',
        prop: 'downloadUrl',
        width: '240px' },

      {
        label: 'zip目录',
        prop: 'unzipOssPath' },

      {
        label: '解压目录',
        prop: 'targetOssPath',
        width: '240px' },

      {
        label: '上传状态',
        prop: 'uploadStatus',
        formatter: _formatter.staticManageUploadStatusFormatter },

      {
        label: '创建人',
        prop: 'createBy' },

      {
        label: '上传时间',
        prop: 'createTime',
        formatter: _formatter.dateFormatter },

      {
        label: '备注',
        prop: 'remark' }]

      //记录表头
    };
  },
  mounted: function mounted() {
    this.brandId = parseInt(this.$route.params.brandId);
    this.$set(this.searchData, 'brandId', this.brandId);
    this.initPage();
  },
  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchDropModelList();
      this.fetchDropBrandList();
      this.fetchLocaleList();
      this.fetchModelList();
    },

    /**
        * 获取下拉型号列表
        */
    fetchDropModelList: function fetchDropModelList() {var _this = this;
      var params = {
        page: 1,
        rows: 9999999,
        brandId: this.brandId };

      this.getData('/api/faDeviceType', params, function (res) {
        _this.modelList = res.list;
      });
    },

    /**
        * 获取下拉品牌列表
        */
    fetchDropBrandList: function fetchDropBrandList() {var _this2 = this;
      this.getData('/api/faBrandInfo/list', {}, function (res) {
        _this2.brandList = res;
      });
    },

    /**
        * 获取语言下拉列表
        */
    fetchLocaleList: function fetchLocaleList() {var _this3 = this;
      this.getData('/api/language/list', {}, function (res) {
        _this3.localeList = res;
      });
    },

    /**
        * 获取型号列表
        */
    fetchModelList: function fetchModelList() {var _this4 = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/faDeviceType', params, function (res) {
        _this4.tableData = res.list;
        _this4.pageData.page = res.pageNum;
        _this4.pageData.total = res.total;
      });
    },

    /**
        * 查询
        */
    handleSearch: function handleSearch() {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', 10);
      this.$set(this.pageData, 'page', 1);
      this.$set(this.pageData, 'rows', 10);
      this.fetchModelList();
    },

    /**
        * 重置
        */
    handleReset: function handleReset() {var _this5 = this;
      Object.keys(this.searchData).forEach(function (e) {
        if (e == 'page') {
          _this5.$set(_this5.searchData, 'page', 1);
          return;
        }
        if (e == 'rows') {
          _this5.$set(_this5.searchData, 'rows', 10);
          return;
        }
        if (e == 'brandId') {
          _this5.$set(_this5.searchData, 'brandId', _this5.brandId);
          return;
        }
        _this5.$set(_this5.searchData, e, '');
      });
      this.$set(this.pageData, 'page', 1);
      this.$set(this.pageData, 'rows', 10);
      this.fetchModelList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.$set(this.pageData, 'page', val);
      this.fetchModelList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.pageData, 'page', 1);
      this.$set(this.pageData, 'rows', val);
      this.$set(this.searchData, 'rows', val);
      this.$set(this.searchData, 'page', 1);
      this.fetchModelList();
    },

    /**
        * 设备H5
        */
    handleDeviceH5: function handleDeviceH5(row) {var _this6 = this;
      this.showPath = true;
      this.$set(this.pathForm, 'fileType', 1);
      this.$set(this.pathForm, 'typeCode', row.code);
      var brand = (0, _lodash.find)(this.brandList, function (o) {
        return o.id == _this6.brandId;
      });
      if (brand) {
        this.$set(this.pathForm, 'brandCode', brand.code);
      }
    },

    /**
        * 说明书
        */
    handleInstroduce: function handleInstroduce(row) {var _this7 = this;
      this.showPath = true;
      this.$set(this.pathForm, 'fileType', 2);
      this.$set(this.pathForm, 'typeCode', row.code);
      var brand = (0, _lodash.find)(this.brandList, function (o) {
        return o.id == _this7.brandId;
      });
      if (brand) {
        this.$set(this.pathForm, 'brandCode', brand.code);
      }
    },

    /**
        * 历史记录
        */
    checkHistory: function checkHistory(row) {var _this8 = this;
      var brand = (0, _lodash.find)(this.brandList, function (o) {
        return o.id == _this8.brandId;
      });
      if (brand) {
        this.$set(this.pathForm, 'brandCode', brand.code);
      }
      this.$set(this.recordSearchData, 'brandCode', brand.code);
      this.$set(this.recordSearchData, 'typeCode', row.code);
      this.fetchUploadRecordHistory();
    },

    /**
        * 获取历史记录
        */
    fetchUploadRecordHistory: function fetchUploadRecordHistory() {var _this9 = this;
      var params = Object.assign({}, this.recordSearchData);
      this.getData('/api/faStaticResUpload', params, function (res) {
        _this9.recordData = res.list;
        _this9.recordPageData.page = res.pageNum;
        _this9.recordPageData.total = res.total;
        _this9.showRecord = true;
      });
    },

    /**
        * 下载文件
        */
    downloadFile: function downloadFile(row) {
      this.$confirm("\u5F53\u524Dzip\u6587\u4EF6\u76EE\u5F55\u5C42\u7EA7\u4E3A\uFF1A".concat(row.folderPath || '', "\uFF0C\u4E0B\u8F7D\u540E\u81EA\u884C\u4FEE\u6539"), '温馨提示', { type: 'warning' }).
      then(function (res) {
        window.location.href = row.downloadUrl;
      });
    },

    /**
        * 记录查询
        */
    handleRecordSearch: function handleRecordSearch() {
      this.$set(this.recordSearchData, 'page', 1);
      this.$set(this.recordSearchData, 'rows', 10);
      this.$set(this.recordPageData, 'page', 1);
      this.$set(this.recordPageData, 'rows', 10);
      this.fetchUploadRecordHistory();
    },

    /**
        * 记录重置
        */
    handleRecordReset: function handleRecordReset() {var _this10 = this;
      Object.keys(this.recordSearchData).forEach(function (e) {
        if (e == 'page') {
          _this10.$set(_this10.recordSearchData, 'page', 1);
          return;
        }
        if (e == 'rows') {
          _this10.$set(_this10.recordSearchData, 'rows', 10);
          return;
        }
        if (e == 'brandCode' || e == 'typeCode') {
          return;
        }
        _this10.$set(_this10.recordSearchData, e, '');
      });
      this.$set(this.recordPageData, 'page', 1);
      this.$set(this.recordPageData, 'rows', 10);
      this.fetchUploadRecordHistory();
    },

    /**
        * 记录-size-change
        */
    handleRecordSizeChange: function handleRecordSizeChange(val) {
      this.$set(this.recordPageData, 'page', 1);
      this.$set(this.recordPageData, 'rows', val);
      this.$set(this.recordSearchData, 'rows', val);
      this.$set(this.recordSearchData, 'page', 1);
      this.fetchUploadRecordHistory();
    },

    /**
        * 记录-页码-change
        */
    handleRecordCurrentChange: function handleRecordCurrentChange(val) {
      this.$set(this.recordSearchData, 'page', val);
      this.$set(this.recordPageData, 'page', val);
      this.fetchUploadRecordHistory();
    },

    /**
        * 路径弹窗关闭
        */
    onPathDialogClose: function onPathDialogClose() {var _this11 = this;
      this.$nextTick(function () {
        Object.keys(_this11.pathForm).forEach(function (e) {
          _this11.$set(_this11.pathForm, e, '');
        });
        _this11.$refs.pathForm.clearValidate();
      });
      this.showPath = false;
    },

    /**
        * 路径提交
        */
    handleSubmitPath: function handleSubmitPath() {var _this12 = this;
      var versionRegex = /^\d+\.\d+\.\d+$/;
      this.$refs.pathForm.validate(function (valid) {
        if (valid) {
          if (!versionRegex.test(_this12.pathForm.version)) {
            _this12.$message({
              type: 'error',
              message: '版本号格式有误' });

            return;
          }
          var params = Object.assign({}, _this12.pathForm);
          _this12.postData('/api/faStaticResUpload/getPath', params, function (res) {
            _this12.$set(_this12.uploadForm, 'fileType', _this12.pathForm.fileType);
            _this12.$set(_this12.uploadForm, 'brandCode', _this12.pathForm.brandCode);
            _this12.$set(_this12.uploadForm, 'typeCode', _this12.pathForm.typeCode);
            _this12.$set(_this12.uploadForm, 'unzipOssPath', res.unzipPath);
            _this12.$set(_this12.uploadForm, 'tempPath', res.domain + '/' + res.fixedPath + res.folderPath);
            _this12.$set(_this12.uploadForm, 'targetOssPath', res.domain + '/' + res.fixedPath + res.folderPath);
            _this12.$set(_this12.uploadForm, 'folderPath', res.folderPath);
            _this12.$set(_this12.uploadForm, 'domain', res.domain);
            _this12.$set(_this12.uploadForm, 'version', _this12.pathForm.version);
            _this12.$set(_this12.uploadForm, 'locale', _this12.pathForm.locale || '');
            _this12.$set(_this12.uploadForm, 'remark', _this12.pathForm.remark || '');
            _this12.onPathDialogClose();
            _this12.showFile = true;
          });
        }
      });
    },

    /**
        * 文件弹窗关闭
        */
    onFileDialogClose: function onFileDialogClose() {var _this13 = this;
      this.$nextTick(function () {
        Object.keys(_this13.uploadForm).forEach(function (e) {
          if (e == 'uploadStatus') {
            _this13.$set(_this13.uploadForm, e, 1);
            return;
          }
          _this13.$set(_this13.uploadForm, e, '');
        });
        _this13.$refs.uploadForm.clearValidate();
      });
      this.showFile = false;
    },

    /**
        * 文件上传
        */
    handleFileUpload: function handleFileUpload(option) {
      this.uploading = true;
      _aliOss.default.ossUploadFile(option, this.uploadForm.unzipOssPath.toString().slice(0, -1), false);
    },

    /**
        * 文件上传前钩子
        */
    handleBeforeUpload: function () {var _handleBeforeUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {var readRes, res;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                readRes = null;if (!(
                this.uploadForm.fileType == 1)) {_context.next = 9;break;}_context.next = 4;return (
                  (0, _index.readZipHtmlFile)(file).
                  catch(function (err) {
                    console.error('catch=====>', err);
                  }));case 4:readRes = _context.sent;
                console.log('readRs============>', readRes);if (
                readRes) {_context.next = 9;break;}
                this.$message({
                  type: 'error',
                  message: '压缩包有误，未读取到*.html' });return _context.abrupt("return",

                Promise.reject(false));case 9:_context.next = 11;return (


                  (0, _index.reorganizeFile)(file, this.uploadForm.folderPath, "".concat(this.uploadForm.brandCode, "_").concat(new Date().getTime())));case 11:res = _context.sent;
                this.$set(this.uploadForm, 'targetOssPath', this.uploadForm.tempPath + (this.uploadForm.fileType == 1 ? "".concat(readRes ? readRes : 'index.html') : res[1] || ''));return _context.abrupt("return",
                res[0]);case 14:case "end":return _context.stop();}}}, _callee, this);}));function handleBeforeUpload(_x) {return _handleBeforeUpload.apply(this, arguments);}return handleBeforeUpload;}(),


    /**
                                                                                                                                                                                                              * 上传成功
                                                                                                                                                                                                              */
    handleSuccess: function handleSuccess(res) {var _this14 = this;
      this.uploading = false;
      var brand = (0, _lodash.find)(this.brandList, function (o) {
        return o.code == _this14.uploadForm.brandCode;
      });
      if (brand) {
        this.$set(this.uploadForm, 'brandName', brand.name);
      }
      this.$set(this.uploadForm, 'downloadUrl', "".concat(this.uploadForm.domain, "/").concat(res.name));
      var nameList = res.name.split('/');
      this.$set(this.uploadForm, 'zipFileName', nameList[nameList.length - 1]);
      this.$refs.uploadForm.clearValidate();
      console.log('uploadForm======>', this.uploadForm);
      this.handleFilePathSave();
    },

    /**
        * 上传失败
        */
    handleError: function handleError() {
      this.uploading = false;
    },

    /**
        * 保存上传记录
        */
    handleFilePathSave: function handleFilePathSave() {var _this15 = this;
      this.$refs.uploadForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this15.uploadForm);
          _this15.postData('/api/faStaticResUpload/add', params, function (res) {
            _this15.$message({
              type: 'success',
              message: '保存成功' });

            // this.onFileDialogClose()
          });
        }
      });
    },

    /**
        * 拷贝路径
        */
    handleCopy: function handleCopy(link) {
      this.$message({
        type: 'success',
        message: '已复制' });

    } } };exports.default = _default;